function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";
import InputBase from "@material-ui/core/InputBase";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";
import FormControl from "@material-ui/core/FormControl";
import { isEdge } from "../../utils/helpers";
const useStyles = makeStyles(({
  palette,
  typography
}) => ({
  root: {
    border: `${typography.pxToRem(1)} solid rgba(0, 0, 0, 0.18)`,
    padding: typography.pxToRem(7),
    background: palette.background.input
  },
  input: {
    fontSize: typography.pxToRem(15),
    lineHeight: 1.1,
    padding: 0,
    fontWeight: 300,
    "&:-webkit-autofill": {
      "&, &:hover, &:focus, &:active": {
        "-webkit-text-fill-color": palette.text.primary,
        transition: "all 99s ease-in-out 0s",
        transitionProperty: "background-color, color",
        transitionDelay: "99s"
      }
    },
    "&::placeholder": {
      fontSize: typography.pxToRem(13)
    }
  },
  withError: {
    border: `${typography.pxToRem(2)} solid ${palette.error.main}`
  }
}));

const Input = ({
  className,
  fullWidth,
  children,
  withError,
  ...rest
}) => {
  const styles = useStyles();
  return /*#__PURE__*/React.createElement(FormControl, {
    className: className,
    fullWidth: fullWidth
  }, /*#__PURE__*/React.createElement(InputBase, _extends({
    classes: {
      root: clsx(styles.root, {
        [styles.withError]: withError
      }),
      input: clsx(styles.input)
    },
    autoComplete: isEdge ? "off" : "on"
    /* $FlowFixMe This comment suppresses an error found when upgrading
     * Flow to v0.112.0. To view the error, delete this comment and run
     * Flow. */

  }, rest)), children);
};

Input.defaultProps = {
  placeholder: "",
  withError: false
};
export default Input;